import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from '../app-routing.module';
import { AuthService } from './service/auth.service';
import { UserService } from '../core/service/user.service';
import { FooterComponent } from './footer/footer.component';

@NgModule({
  imports: [
    CommonModule,FormsModule,
    AppRoutingModule
  ],
  exports:[HeaderComponent, FooterComponent],
  declarations: [HeaderComponent, FooterComponent],
  providers: [
    AuthService,
    UserService,
  ]
})
export class CoreModule {

  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error( 'CoreModule has already been loaded. Import Core modules in the AppModule only.' );
    }
  }

 }


// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/The-Top/src/app/core/core.module.ts